import { memo } from 'react';

export interface UserProfileHeaderProps {
  readonly initials: string;
  readonly email: string;
  readonly displayName?: string | null;
  readonly organizationLabel?: string | null;
}

/**
 * Account identity strip — avatar · name · email (no account-type / role label).
 */
export const UserProfileHeader = memo(
  ({
    initials,
    email,
    displayName = null,
    organizationLabel = null,
  }: UserProfileHeaderProps): JSX.Element => {
    const title =
      displayName != null && displayName.trim().length > 0 ? displayName.trim() : email;

    return (
      <div className="flex items-center gap-3" data-testid="user-profile-header">
        <div
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[var(--color-an-primary)] text-sm font-bold text-[var(--color-an-on-primary,#ffffff)]"
          aria-hidden="true"
        >
          {initials}
        </div>
        <div className="min-w-0">
          <p className="m-0 truncate text-sm font-semibold text-[var(--color-an-text)]">{title}</p>
          <p className="m-0 truncate text-sm text-[var(--color-an-text-muted)]">{email}</p>
          {organizationLabel != null && organizationLabel.trim().length > 0 ? (
            <p className="m-0 truncate text-xs text-[var(--color-an-text-muted)]">
              {organizationLabel}
            </p>
          ) : null}
        </div>
      </div>
    );
  },
);

UserProfileHeader.displayName = 'UserProfileHeader';
